import { registerSW } from 'virtual:pwa-register';

type Callbacks = {
  onNeedRefresh: () => void;
  onOfflineReady: () => void;
};

/**
 * Registers the service worker and returns a function that activates the
 * waiting worker and reloads the page.
 *
 * Registration is deliberately manual rather than injected: it keeps the
 * update prompt under React's control instead of reloading out from under
 * whatever the user is doing.
 */
export function setupPWA({ onNeedRefresh, onOfflineReady }: Callbacks) {
  return registerSW({
    immediate: true,
    onNeedRefresh,
    onOfflineReady,
    onRegisteredSW(swUrl, registration) {
      if (!registration) return;
      // Browsers only check for a new worker on navigation. Poll hourly so
      // long-lived installed sessions still pick up deploys.
      setInterval(
        () => {
          if (registration.installing || !navigator.onLine) return;
          void registration.update();
        },
        60 * 60 * 1000,
      );
      if (import.meta.env.DEV) {
        console.info('[pwa] service worker registered:', swUrl);
      }
    },
    onRegisterError(error) {
      console.error('[pwa] service worker registration failed:', error);
    },
  });
}
